import { withProps, compose } from 'recompose'
import React from 'react'
import Markdown from 'react-markdown'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { Chip } from 'material-ui'
import LocIcon from 'material-ui/svg-icons/communication/location-on'

import { trackEvent } from '../../app/ga'
import {
  getFeedbackCfg,
  getFeedbackDefinition,
  getSocialShareDefinition,
  getSessions,
} from '../../app/selectors'
import content from '../../content'
import SocialBar from '../../addons/social/SocialBar'
import Feedback from '../../addons/feedback/Feedback'
import TimeIcon from '../../assets/svg/TimeIcon'
import PresenterIcon from '../../assets/svg/PresenterIcon'
import InlineIconWrapper from '../../components/InlineIconWrapper'

function buildShareMessage(messageTemplate, presentation) {
  return messageTemplate.replace(/{title}/g, presentation.title)
}

const IconChip = ({ children, style, labelStyle, ...props }) => (
  <Chip
    style={{ height: 20, minWidth: 66, padding: '0 8px', ...style }}
    labelStyle={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 0,
      lineHeight: 20,
      ...labelStyle,
    }}
    {...props}
  >
    {children}
  </Chip>
)

function PresentationContent({
  presentation,
  session,
  feedbackCfg,
  feedbackDef,
  socialShareDef,
  muiTheme,
}) {
  const { custom: { metrics: { basePadding } } } = muiTheme
  const { title, subtitle, text, presenter } = presentation
  const { time, endTime, track } = session
  const { providers, message, hashtag, url } = socialShareDef
  const shareMessage = buildShareMessage(message, presentation)
  return (
    <div>
      {!presenter.metaOnly && (
        <div
          className="PresentationDetailPage-presenterPicture"
          style={{ margin: -basePadding }}
        >
          <img src={presenter.picture} alt={presenter.fullName} />
          <div className="PresentationDetailPage-chips">
            {time ? (
              <IconChip backgroundColor="#a6a8ab">
                <TimeIcon style={{ width: 12, height: 12 }} color="#ffffff" />
                <span className="PresentationDetailPage-chipLabel">
                  {time}
                  {endTime ? ` - ${endTime}` : ''}
                </span>
              </IconChip>
            ) : (
              <div />
            )}
            {track ? (
              <IconChip backgroundColor={track.color}>
                <LocIcon style={{ width: 15, height: 15 }} color="#ffffff" />
                <span className="PresentationDetailPage-chipLabel">
                  {track.label}
                </span>
              </IconChip>
            ) : (
              <div />
            )}
          </div>
        </div>
      )}
      <div>
        <h2>{title}</h2>
        <h3>{subtitle}</h3>
        {!presenter.metaOnly && (
          <div className="PresentationDetailPage-presenter">
            <InlineIconWrapper iconComponent={PresenterIcon}>
              {presenter.fullName}
            </InlineIconWrapper>
          </div>
        )}
        <Markdown source={text} className="PresentationDetailPage-text" />
        <SocialBar
          url={url}
          providers={providers}
          message={shareMessage}
          hashtag={hashtag}
          beforeShare={provider => trackEvent('social', provider, title)}
        />
      </div>
      <Feedback
        cfg={feedbackCfg}
        subjectId={'presentation_' + presentation.id}
        definition={feedbackDef}
      />
    </div>
  )
}

function getSessionForPresentation(presentation, content) {
  return getSessions(content).find(
    s => s.presentation && s.presentation.id === presentation.id
  )
}

const withPageContent = withProps(ownProps => ({
  feedbackCfg: getFeedbackCfg(content),
  feedbackDef: getFeedbackDefinition(content, 'presentation'),
  socialShareDef: getSocialShareDefinition(content, 'presentation'),
  // TODO: get all sessions and display all date/times
  // currently date/time from the first found session is used
  session: getSessionForPresentation(ownProps.presentation, content),
}))

export default compose(withPageContent, muiThemeable())(PresentationContent)



// WEBPACK FOOTER //
// ./src/containers/PresentationDetail/PresentationContent.js